import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyBgFxJjveDoU0_Ze2JpgBSsQSqfh7n6XH0",
//   authDomain: "promocoes-8a603.firebaseapp.com",
//   projectId: "promocoes-8a603",
//   storageBucket: "promocoes-8a603.firebasestorage.app",
//   messagingSenderId: "436068135350",
//   appId: "1:436068135350:web:386ac18bba2b6a2d00d117"
// };

const firebaseConfig = {
  apiKey: "AIzaSyC4C_8XtMXBK5RplX2jZfGCen9-p-hlpr8",
  authDomain: "maenopromos-ce894.firebaseapp.com",
  projectId: "maenopromos-ce894",
  storageBucket: "maenopromos-ce894.firebasestorage.app",
  messagingSenderId: "288518212543",
  appId: "1:288518212543:web:b79c52bfffa87e0321af0a"
};


const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };

